import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { CheckCircleIcon } from "@heroicons/react/24/outline";
import trackerSvg from "/360Tracker.svg";
import { routeEndpoints } from "../../../../routes/routeEndpoints";

const Hero = () => {
  const [orderId, setOrderId] = useState("");
  const navigate = useNavigate();

  const handleSearch = () => {
    if (orderId.trim()) {
      navigate(`${routeEndpoints.order}?id=${orderId}`);
    }
  };

  return (
    <section className="w-full overflow-x-hidden mx-auto lg:px-21 md:px-10 md:py-5 py-2 px-4 flex flex-col md:flex-row items-center gap-6">
      <div className="flex-1 w-full">
        <span className="inline-flex items-center px-3 py-2 mb-3 rounded-full text-sm font-normal bg-blue-50 text-blue-600 border border-blue-100">
          <CheckCircleIcon className="w-6 h-6 mr-2" /> Service Order Tracking
          Platform
        </span>
        <h1 className="md:text-5xl text-3xl text-balance font-semibold mb-5 text-gray-900 leading-tight">
          Service Orders Made Easy to Track and Manage
        </h1>
        <p className="text-gray-500 md:text-xl text-sm font-normal">
          Track repairs, parts, service history, and order status on a simple
          and secure platform.
        </p>
        <div className="flex flex-col md:flex-row gap-6 md:max-w-xl md:pt-10 pt-8 w-full">
          <input
            type="text"
            placeholder="Enter your order ID"
            value={orderId}
            onChange={(e) => setOrderId(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && handleSearch()}
            className="flex-1 px-4 py-3.5 w-full rounded-lg border border-gray-300 text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 bg-gray-50/50"
          />
          <button
            onClick={handleSearch}
            className="bg-[#0066FF] text-white px-12 w-full md:w-auto py-3.5 rounded-xl font-medium text-base hover:bg-blue-700 transition-all cursor-pointer"
          >
            Confirm
          </button>
        </div>
      </div>
      <div className="hidden   md:flex flex-1 justify-center w-full">
        <div className="relative w-full max-w-md">
          <div className="absolute inset-0 rounded-full blur-3xl opacity-20"></div>
          <img
            src={trackerSvg}
            alt="360 Tracker"
            className="relative z-10 w-full h-full object-contain"
          />
        </div>
      </div>
    </section>
  );
};

export default Hero;
